import { HttpService } from "@/core";
import { FileReq } from "@/core/services/biz-file.interface";

// 取消开票 ==> 发票流
export const updateStatusTicketManage = () => {
  const api = ( data: any = {}) =>
    HttpService.axios({
      method: "POST",
      url:`/common_api/invoiceStatusChange`,
      data
    });
  return  HttpService.useRequest<any>(api);
};


export const updateStatusTicketManage2 = (files: FileReq[], bizId: string, bizType: string, bizFileType: string = '', contractStatus: string = '', operationDescType: string = '', operationDesc: string = '') => {
  const api = ( data: any = {}) =>
    HttpService.axios({
      method: "POST",
      url:`/common_api/invoiceStatusChange`,
      data: {bizId, bizType, fileObjAReq: { bizFiles: files, bizId, bizFileType }, contractStatus, operationDescType, operationDesc},
    });
  return  HttpService.usePagination<any>(api);
};

// 开票申请=>取消申请==>资金流
export const updateStatusOffPayment = () => {
  const api = ( data: any = {}) =>
    HttpService.axios({
      method: "POST",
      url:`/common_api/fundStatusChange`,
      data
    });
  return  HttpService.useRequest<any>(api);
};

export class SignService {
  static updateStatusTicketManage = () => {
    const api = ( data: any = {}) =>
      HttpService.axios({
        method: "POST",
        url:`/common_api/invoiceStatusChange`,
        data
      });
    return  HttpService.usePagination<any>(api);
  };
  // 按钮弹窗，修改合同状态的公共接口
  static useContractStatusChangeApi() {
    const api = (files: FileReq[], bizId: string, bizType: string, bizFileType: string = '', status: string = '', operationDescType: string = '', operationDesc: string = '') =>
      HttpService.axios({
        method: "POST",
        url: `/common_api/invoiceStatusChange`,
        data: {bizId, bizType, fileObjAReq: { bizFiles: files, bizId, bizType:bizFileType }, status, operationDescType, operationDesc},
      });
    return HttpService.useRequest(api);
  }

  static updateStatusOffPayment = () => {
    const api = ( data: any = {}) =>
      HttpService.axios({
        method: "POST",
        url:`/common_api/fundStatusChange`,
        data
      });
    return  HttpService.usePagination<any>(api);
  };
}
